module.exports = __webpack_public_path__ + "static/media/CoinMarketCap.6e6f05a8.png";